import { gql } from '@apollo/client';

export const UpdateStandardImportDraftMutationName =
  'UpdateStandardImportDraft';

export const UPDATE_STANDARD_IMPORT_DRAFT_MUTATION = gql`
  mutation ${UpdateStandardImportDraftMutationName}(
    $id: ID!
    $draft: SmartImportDraftInput!
  ) {
    updateStandardImportDraft(id: $id, draft: $draft) {
      standardImport {
        id
        status
        updatedAt
        draft {
          revision
        }
      }
    }
  }
`;
